var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_1180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27736 23.6912C4.89561 23.2921 4.90967 22.6591 5.30878 22.2774L16.0533 12L5.30878 1.72264C4.90967 1.34089 4.89561 0.707883 5.27736 0.308778C5.65911 -0.0903252 6.29212 -0.104392 6.69122 0.27736L18.1912 11.2774C18.3885 11.466 18.5 11.7271 18.5 12C18.5 12.2729 18.3885 12.534 18.1912 12.7226L6.69122 23.7226C6.29212 24.1044 5.65911 24.0903 5.27736 23.6912Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_1180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/Caret Right.27b29a88eee352a59ff6bc8f302f266c.svg";
export { ForwardRef as ReactComponent };